/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Grid2 from "@mui/material/Grid2";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "../../../components/MKTypography";

function DefaultFooter() {
  return (
    <MKBox component="footer">
      <Grid2 container sx={{ textAlign: "center", justifyContent: 'left', ml : 2}}>
          <MKTypography variant="body2" color="dark" fontWeight="regular" sx={{ my: 0.5, fontSize: '13px', mr: 2 }}> {/* margin 조정 */}
            회사명 : (주) 립플레이스 (LEAP PLACE)
          </MKTypography>
          <MKTypography variant="body2" color="dark" fontWeight="regular" sx={{ my: 0.5, fontSize: '13px', mr: 2 }}> {/* margin 조정 */}
            대표 : 안창현 & 김남균
          </MKTypography>
          <MKTypography variant="body2" color="dark" fontWeight="regular" sx={{ my: 0.5, fontSize: '13px', mr: 2 }}> {/* margin 조정 */}
            이메일 : shark1007@leap-place.com
          </MKTypography>
          <MKTypography variant="body2" color="dark" fontWeight="regular" sx={{ my: 0.5, fontSize: '13px', mr: 2 }}> {/* margin 조정 */}
            사업자등록번호 : 410-88-03162
          </MKTypography>
      </Grid2>
      <Grid2 container sx={{ textAlign: "center", justifyContent: 'left', ml : 2}}>
          <MKTypography variant="body2" color="dark" fontWeight="regular" sx={{ my: 0.5, fontSize: '13px' }}> {/* margin 조정 */}
            COPYRIGHT (c) (주) 립플레이스 ALL RIGHTS RESERVED.
          </MKTypography>
      </Grid2>
    </MKBox>
  );
}

// Typechecking props for the DefaultFooter
DefaultFooter.propTypes = {
  content: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.object, PropTypes.array])).isRequired,
};

export default DefaultFooter;
